<template>
  <header class="sp-password-header" :class="{ inline }">
    <DaichoLogo />
  </header>
</template>

<script>
import DaichoLogo from '@/components/icons/logo'

export default {
  name: 'SpPasswordHeader',
  components: {
    DaichoLogo,
  },
  props: {
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.sp-password-header {
  background: var(--moderate-blue);
  box-sizing: border-box;
  height: 56px;
  left: 0;
  padding: 20px;
  position: sticky;
  top: 0;
  width: 100%;

  svg {
    fill: var(--white);
  }

  &.inline {
    position: static;
  }

  .responsive & {
    @media screen and (max-width: 559px) {
      position: static;
    }
  }
}
</style>
